<template>
    <div>
        <div class="grid grid-cols-[repeat(11,_minmax(0,_1fr))_35px] gap-3 font-bold py-2">
            <span class="col-span-3">Valuta</span>
            <span class="col-span-3">Valore in euro</span>
            <span class="col-span-3">Dati di cambio</span>
            <span class="col-span-1">Pred. A</span>
            <span class="col-span-1">Pred. V</span>
        </div>
        <div class="grid grid-cols-[repeat(11,_minmax(0,_1fr))_35px] gap-3 mb-3" v-for="(f,i) in valute_data" :key="i">
            <div class="col-span-3">
                <Field v-model="f.descrizione" :label-visible="false" placeholder="Valuta">
                    <VueMultiselect
                        :searchable="true"
                        :internal-search="false"
                        trackBy="CG08_SIGLA"
                        label="CG08_DESCR"
                        @search-change="valutaAutcomplete.search"
                        v-model="f.valuta"
                        @update:modelValue="setValuta(f, $event)"
                        :options="valutaAutcomplete.options"
                        :close-on-select="true" :clear-on-select="true"
                        placeholder="Valuta"
                        deselectLabel="Deseleziona"
                        selectedLabel="Selezionato"
                        selectLabel="Seleziona"
                        class="next-vue-multiselect-single"
                    >
                    </VueMultiselect>
                </Field>
            </div>
            <div class="col-span-3 flex items-center">
                <span class="whitespace-nowrap mr-1" style="flex: 0 0 70px">1 {{ f.valuta?.CG08_SIGLA }} = </span>
                <Field v-model="f.valore" :label-visible="false" placeholder="Valore in euro" type="number"
                       :input-attrs="{step:0.000001}"></Field>
                <span class="whitespace-nowrap ml-1">€</span>
            </div>
            <div class="col-span-3">
                <Field v-model="f.data" :label-visible="false" type="date"></Field>
            </div>
            <div class="flex justify-center">
                <Radio :value="i" name="default_acq" :modelValue="default_acq" @update:modelValue="updateValAcq"
                       checkClass="w-3 h-3"></Radio>
            </div>
            <div class="flex justify-center">
                <Radio :value="i" name="default_ve" :modelValue="default_ve" @update:modelValue="updateValVe"
                       checkClass="w-3 h-3"></Radio>
            </div>
            <NextButton variant="primary" @click="addValuta" v-if="i === valute_data.length-1"
                        class="flex justify-center items-center"><i class="icon-croce_quadrata"></i></NextButton>
            <NextButton variant="outline-secondary" @click="removeValuta(i)" v-else
                        class="flex justify-center items-center"><i class="icon-x"></i></NextButton>
        </div>

        <div class="flex justify-end">

            <NextButton variant="outline-secondary"
                        @click="chiudi"
                        class="col-start-4 col-span-3 py-2 px-4">
                Chiudi
            </NextButton>
            <NextButton variant="primary"
                        @click="salva"
                        class="col-span-3 ml-4 py-2 px-4">
                Salva
            </NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import Autocomplete from "@/setup/Autocomplete";
import valutaManager from "../api/ValutaManager";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import Radio from "@/components/Radio.vue";

@Options({
    name: 'CambioValutaForm',
    components: {
        Radio,
        Field,
        NextButton,
    },
    props: {
        valute: Array,
        visible: Boolean,
    }
})
export default class CambioValutaForm extends Vue {
    valutaAutcomplete: any = setup(() => Autocomplete(valutaManager))
    valute_data: any[] = []
    valute!: any
    default_ve: number|null = -1
    default_acq: number|null = -1

    init() {
        // li riparseo per evitare che quando chiudo il modal senza salvare mi vada a modificare l'oggetto originario
        let valute_data = JSON.parse(JSON.stringify(this.valute))
        if (!valute_data.length) {
            valute_data = [{valuta: undefined, valore: undefined, data: undefined}]
        }
        const defac = valute_data.findIndex((el: any) => el.default_acq)
        if (defac > -1) {
            this.default_acq = defac
        }

        const defve = valute_data.findIndex((el: any) => el.default_ve)
        if (defve > -1) {
            this.default_ve = defve
        }
        this.valute_data = valute_data
        this.valutaAutcomplete.search('')
    }

    created() {
        this.init()
    }

    setValuta(f: any, event: any) {
        if (event) {
            f.valuta = event;
            f.descrizione = event['CG08_DESCR'];
            f.sigla = event['CG08_SIGLA'];
        } else {
            f.valuta = null;
            f.descrizione = '';
            f.sigla = '';
        }
    }

    addValuta() {
        this.valute_data.push({valute: undefined, valore: undefined, data: undefined})
    }

    removeValuta(i: number) {
        this.valute_data.splice(i, 1)
    }

    salva() {
        this.$emit('update:valute', this.valute_data.map((el, i) => {
            return {...el, id: i, default_acq: i === this.default_acq, default_ve: i === this.default_ve}
        }))
        this.chiudi()
    }

    chiudi() {
        this.$emit('chiudi')
    }

    updateValVe($event: number) {
        this.default_ve = (this.default_ve == $event ? null : $event)
    }

    updateValAcq($event: any) {
        this.default_acq = (this.default_acq == $event ? null : $event)
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
